export default __webpack_public_path__ + "static/media/designer_ (2).2c817382.svg";